import { TypeGroupIds } from "../modules/shared/constants/category-groupid.constants";

export enum AddressTypeName {
    BILLING = "Billing",
    SHIPPING = "Shipping"
}

export enum AddressTypeId {
    BILLING = 38,
    SHIPPING = 39,
    OTHER = 40
}

export enum AccountGroupId {
    ID = TypeGroupIds.AccountTypeAccountAPI
};

export const AccountViewTabIndex = {
    OVERVIEW: 0,
    ACTIVITY: 1,
    List:2,
    CONTACT: 3,
   // TASK: 4,
    DOCUMENTS: 4,
    UserAccess: 5,
    OPPORTUNITY: 6,
    CASES: 7,
    FINANCE: 8 
};

export enum AccountViewTabIndexWithContact {
    OVERVIEW,
    ACTIVITY,
    TASK,
    DOCUMENTS,
    UserAccess,
    OPPORTUNITY,
    CASES
};

export enum Status {
    Active = 1,
    InActive = 2,
    Deleted = 3
}
